import Slider from '../classes/Slider';

const selectors = {
    el: '.js-slider:not(.is-ready)'
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-ready');
        /* eslint-disable no-new */
        new Slider(el);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;